export function capitalizeWords(text?: string | null): string {
	return text ? text.replace(/(^|\s)(\p{Ll})/gu, (_, space, letter) => space + letter.toUpperCase()) : '';
}
